<template>
<div>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal" v-if="modal_loading == false">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">Update notification preferences for {{ first_name }} {{ last_name }}</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="form-group row">
          <div class="field_heading">Communication</div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 40px; padding-bottom: 5px;">
            <input
              type="checkbox"
              v-bind:id="news_subscription"
              v-bind:name="news_subscription"
              ref="news_subscription"
              v-model="news_subscription_selected"
              :checked="news_subscription_checked"
              :value="1" style="margin-top: 4px; height: 11px;"
              >
            <label class="" for="submit_comment_1">News, updates, promotions & more!</label>
          </div>

          <div class="field_heading">Frequency</div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 20px; padding-bottom: 5px;">
            <div class="custom-control " >
                <div class="col-8 p-0 float-left">
                <label for="notification"  style="padding-top:2px;">Mentoring support communication</label>
                </div>
                <div class="search-padd float-left col-4">
                    <select 
                    class="custom-select" 
                    id="frequency" 
                    name="frequency"
                    v-model="frequency"
                    :disabled="frequency_disabled"
                    v-validate="'required'">
                    <option v-for="(item, index) in frequency_options" :key="index" :value="item.value">{{ item.text }}</option>
                    </select>
                </div>
                <div style="clear: both;"></div>
            </div>
          </div>


          <div class="field_heading">System Related Notifications</div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 40px; padding-bottom: 5px;">
            <input
              type="checkbox"
              v-bind:id="disable_notification"
              v-bind:name="disable_notification"
              ref="disable_notification"
              v-model="disable_notification_selected"
              :checked="disable_notification_checked"
              :value="1" style="margin-top: 2px; height: 11px;"
              @change="getDisableNotificationSelected($event)">
            <label class="" for="submit_comment_1" style="padding-top:-10px;">Disable all Mentor Mentee notifications</label>


          </div>


        </div>
        <div class="col-12" style="margin-top: 30px;">
          <div class="col-6 float-left p-0">
            <button type="submit" class="btn btn-sm ma-white-btn" @click="closeModal()">Cancel</button>
          </div>
          <div class="col-6 float-left text-align-right p-0">
            <button type="submit" class="btn btn-sm ma-blue-btn" @click="openConfirmModal()">Update</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
      </div>



</div>
</div>
      <PreferenceUpdateConfirmModal :isModalVisible="isPrefereceUpdateConfirmModalVisible"  @close="isPrefereceUpdateConfirmModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_title }}</div>
        <div slot="body">
          <span v-html="modal_message"></span>
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-6 float-left p-0">
            <button class="btn btn-sm ma-white-btn" @click="closeConfirm()">Cancel</button>
          </div>
          <div class="col-6 float-left p-0 text-align-right">
            <button class="btn btn-sm ma-blue-btn" @click="onSubmit()">Update</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </PreferenceUpdateConfirmModal>



      <SuccessConfirmModal :isModalVisible="isSuccessConfirmModalVisible"  @close="isSuccessConfirmModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_success_title }}</div>
        <div slot="body">
          <span v-html="modal_success_message"></span>
        </div>
        <div slot="footer" class="col-12 p-0">
          <div class="col-12 text-center">
            <button class="btn btn-sm ma-blue-btn" @click="closeSuccessConfirm()">Close</button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </SuccessConfirmModal>


</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import PreferenceUpdateConfirmModal from '../admin/preference_confirm_modal.vue';
import SuccessConfirmModal from '../admin/preference_confirm_modal.vue';



Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: [
    'isModalVisible',
    ],
  data() {
    return {
        loading: false,
        submit_form_errors: '',
        news_subscription: 'news_subscription',
        news_subscription_checked: 1,
        disable_notification_checked: 0,
        news_subscription_selected: true,
        disable_notification_selected: false,
        frequency: 'daily',
        old_news_subscription_selected: false,
        old_disable_notification_selected: false,
        old_frequency: 'daily',
        success_msg: '',
        email_subject: '',
        email_message: '',
        vmessage: '',
        first_name: '',
        last_name: '',
        modal_title: '',
        modal_message: '',
        modal_success_title: '',
        modal_success_message: '',
        userId: '',
        accountId: '',
        frequency_options: [
            {value: '', text: 'Select Frequency'},
            {value: 'Daily', text: 'Daily (Default)'},
            {value: 'Tuesdays', text: 'Tuesdays'},
            {value: 'Wednesdays', text: 'Wednesdays'},
            {value: 'Thursdays', text: 'Thursdays'},
        ],
        disable_notification: 0,
        to_email: '',
        isPrefereceUpdateConfirmModalVisible: false,
        isSuccessConfirmModalVisible: false,
        userStatus: '',
        frequency_disabled: false,
        modal_loading: false,

    }
  },
  methods: {
    getDisableNotificationSelected(event) {        
        if(event.target.checked == true) {
            this.frequency = '';
            this.frequency_disabled = true;
        }
        else {
            this.frequency_disabled = false;
        }
    },
    openConfirmModal: function() {
      if(this.disable_notification_selected == true) {
        this.frequency = '';
      }
      if((this.old_news_subscription_selected == this.news_subscription_selected) && (this.old_disable_notification_selected == this.disable_notification_selected) && (this.old_frequency == this.frequency)) {
        this.modal_success_title = 'No Changes found!';
        this.modal_success_message = '';
        this.isModalVisible = false;
        this.isPrefereceUpdateConfirmModalVisible = false;
        this.isSuccessConfirmModalVisible = true;


      }
      else if((this.disable_notification_selected == true) && (this.old_disable_notification_selected != true)) {
        if((this.news_subscription_selected == true) && (this.old_news_subscription_selected != true)) {
          this.modal_title = 'Are you sure want to perform the following changes:';
          this.modal_message = '<ul><li>Disabling the Mentor Mentee Notification</li><li>Subscribing the News, updated and promotions.</ul>';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
        else if((this.news_subscription_selected == false) && (this.old_news_subscription_selected != false)) {
          this.modal_title = 'Are you sure want to perform the following changes:';
          this.modal_message = '<ul><li>Disabling the Mentor Mentee Notification</li><li>Unsubscribing the News, updated and promotions.</ul>';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
        else if((this.news_subscription_selected == this.old_news_subscription_selected)) {
          this.modal_title = 'Are you sure want to disable the Mentor Mentee notification?';
          this.modal_message = '';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
      }
      else if((this.disable_notification_selected == false) && (this.old_disable_notification_selected != false)) {
        if((this.news_subscription_selected == true) && (this.old_news_subscription_selected != true)) {
          this.modal_title = 'Are you sure want to perform the following changes:';
          this.modal_message = '<ul><li>Change the Mentoring support communication frequency</li><li>Subscribing the News, updated and promotions.</ul>';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
        else if((this.news_subscription_selected == false) && (this.old_news_subscription_selected != false)) {
          this.modal_title = 'Are you sure want to perform the following changes:';
          this.modal_message = '<ul><li>Change the Mentoring support communication frequency</li><li>Unsubscribing the News, updated and promotions.</ul>';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
        else if((this.news_subscription_selected == this.old_news_subscription_selected)) {
          this.modal_title = 'Are you sure you want to change the frequency of your Mentor Mentee support Communication?';
          this.modal_message = 'A successful mentoring program is based on consistent communication. <i>Mentor Mentee recommends your communication frequency remain on default.</i>';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
      }
      else if((this.news_subscription_selected != this.old_news_subscription_selected) && (this.disable_notification_selected == this.old_disable_notification_selected) && (this.old_frequency == this.frequency)) {
        if((this.news_subscription_selected == true)) {
          this.modal_title = 'Are you sure want to subscribe ' + this.first_name + ' ' + this.last_name + ' to news, updates, promotions & more!?';
          this.modal_message = '';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;

        }
        else if((this.news_subscription_selected == false)) {
          this.modal_title = 'Are you sure want to unsubscribe ' + this.first_name + ' ' + this.last_name + ' from news, updates, promotions & more!?';
          this.modal_message = '<b>Note:</b> ' + this.first_name + ' ' + this.last_name + ' will still receive transactional & account-related support emails.';
          this.isModalVisible = false;
          this.isPrefereceUpdateConfirmModalVisible = true;
        }
      }
      else {
        this.modal_title = 'Are you sure you want to change the frequency of your Mentor Mentee support Communication?';
        this.modal_message = 'A successful mentoring program is based on consistent communication. <i>Mentor Mentee recommends your communication frequency remain on default.</i>';
        this.isModalVisible = false;
        this.isPrefereceUpdateConfirmModalVisible = true;
      }
    },
    closeSuccessConfirm() {
      this.isSuccessConfirmModalVisible = false;
      this.$emit('close');
      this.navigate();
    },
    closeConfirm() {
      this.isModalVisible = false;
      this.isPrefereceUpdateConfirmModalVisible = false;
      this.$emit('close');
    },
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
    },
    getUserPreferenceDetails: function() {
      this.modal_loading = true;
      axios.get('/account-lookup/get-user-preference', {      
          params: {
              account_id: this.accountId,
              user_id: this.userId,
          }  
      })
      .then(response =>  {
        this.frequency_disabled = false;
        this.news_subscription_selected = response.data.isSubscribeNews;
        this.disable_notification_selected = response.data.isDisableNotify;
        if(this.disable_notification_selected == true) {
          this.frequency_disabled = true;
          this.disable_notification_checked = 1;
        }
        else {
          this.disable_notification_checked = 0;
        }
        this.frequency = response.data.frequencyType;
        this.old_frequency = response.data.frequencyType;
        if((!this.frequency) && (this.disable_notification_selected == false)) {
          this.frequency = 'Daily';
          this.old_frequency = 'Daily';
        }
        this.old_news_subscription_selected = response.data.isSubscribeNews;
        this.old_disable_notification_selected = response.data.isDisableNotify;
        this.modal_loading = false;
      })
      .catch(function(error) {
        console.log(error);
      });

    },
    onSubmit() {
      this.vmessage = "show_vmessage";
      axios('/account_lookup/user_preference_update',
          {
          method: 'POST',
          data: {
              isSubscribeNews: this.news_subscription_selected,
              isDisableNotify: this.disable_notification_selected,
              frequencyType: this.frequency,
              account_id: this.accountId,
              user_id: this.userId,
          }
          },
      )
      .then(response => {
          if((this.disable_notification_selected == true) && (this.old_disable_notification_selected != true)) {
            if((this.news_subscription_selected == true) && (this.old_news_subscription_selected != true)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = '<ul><li>Disabled all Mentor Mentee Notifications.</li><li>Subscribed to mentoring news, updates, promotions & more!</li></ul>';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
            else if((this.news_subscription_selected == false) && (this.old_news_subscription_selected != false)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = '<ul><li>Disabled all Mentor Mentee Notifications.</li><li>UnSubscribed to mentoring news, updates, promotions & more!</li></ul>';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
            else if((this.news_subscription_selected == this.old_news_subscription_selected)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Disabled all Mentor Mentee Notifications.';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
          }
          else if((this.disable_notification_selected == false) && (this.old_disable_notification_selected != false)) {
            if((this.news_subscription_selected == true) && (this.old_news_subscription_selected != true)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = '<ul><li>The notification preference for ' + this.first_name + ' ' + this.last_name + ' have been updated to ' + this.frequency + '.</li><li>Subscribed to mentoring news, updates, promotions & more!.</li></ul>';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
            else if((this.news_subscription_selected == false) && (this.old_news_subscription_selected != false)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = '<ul><li>The notification preference for ' + this.first_name + ' ' + this.last_name + ' have been updated to ' + this.frequency + '.</li><li>Unsubscribed to mentoring news, updates, promotions & more!</li></ul>';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
            else if((this.news_subscription_selected == this.old_news_subscription_selected)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'The notification preference for ' + this.first_name + ' ' + this.last_name + ' have been updated to ' + this.frequency + '.';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
          }
          else if((this.news_subscription_selected != this.old_news_subscription_selected) && (this.disable_notification_selected == this.old_disable_notification_selected) && (this.old_frequency == this.frequency)) {
            if((this.news_subscription_selected == true)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Subscribed to mentoring news, updates, promotions & more!';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;

            }
            else if((this.news_subscription_selected == false)) {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'Unsubscribed to mentoring news, updates, promotions & more!';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
            }
          }
          else {
              this.modal_success_title = 'Mentoring Support Communication Updated';
              this.modal_success_message = 'The notification preference for ' + this.first_name + ' ' + this.last_name + ' have been updated to ' + this.frequency + '.';
              this.isModalVisible = false;
              this.isPrefereceUpdateConfirmModalVisible = false;
              this.isSuccessConfirmModalVisible = true;
          }

          //this.navigate();
      })
      .catch(error => {

      })

    },
    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    }
  },
  components: {
    PreferenceUpdateConfirmModal,
    SuccessConfirmModal,
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
  color: #002F42;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #002F42;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #002F42;
  font-size: 14px;
  font-weight: 900;
  line-height: 1;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.field_heading {
  font-size: 13px;
  font-weight: 900;
  width: 100%;
  padding-left: 25px;
  padding-bottom: 0px;
}
.ma-blue-btn {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
.ma-white-btn {
  color: #00ACEE !important; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  font-weight: 900;
  border-radius: 10px;
  width: 90px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.ma-reset-password-btn, .ma-reset-password-btn:focus, .ma-reset-password-btn:active, .ma-reset-password-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 35px;
  margin-top: -5px;
}
.custom-control-input {
  z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_user_preference_modal.vue